const APP_PATH = process.env.REACT_APP_PATH || '/'

const WONDE_CLIENT_ID = 6

export { APP_PATH, WONDE_CLIENT_ID }
